"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { AccountSessionMixins } from "@/service/account-session";
import { Component, PropSync, Mixins } from "vue-property-decorator";
import ShopOnline from "@/views/shopItems/components/ShopOnline.vue";
let ColumnName = class extends Mixins(AccountSessionMixins) {
};
__decorateClass([
  PropSync("column")
], ColumnName.prototype, "_column", 2);
ColumnName = __decorateClass([
  Component({
    components: {
      ShopOnline
    }
  })
], ColumnName);
export {
  ColumnName as default
};
